import { Button, Col, Row, Select } from "antd";
import { Box, Grid, Modal } from "@mui/material";
import { useState } from "react";
import { useRemissionExcelByMonthYear } from "../../../hooks/remission/useRemissionExcelByMonthYear.hook";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const months = [
    { value: '1', label: 'Enero' },
    { value: '2', label: 'Febrero' },
    { value: '3', label: 'Marzo' },
    { value: '4', label: 'Abril'},
    { value: '5', label: 'Mayo'},
    { value: '6', label: 'Junio'},
    { value: '7', label: 'Julio'},
    { value: '8', label: 'Agosto'},
    { value: '9', label: 'Septiembre'},
    { value: '10', label: 'Octubre'},
    { value: '11', label: 'Noviembre'},
    { value: '12', label: 'Diciembre'},
]

const years = Array.from({ length: new Date().getFullYear()- 2022 }).map( (_, index) => ({ value: 2023 + index, label: `${2023 + index}` }));

export function RemissionExcel(){

    const [ open, setOpen ] = useState(false);
    const hook = useRemissionExcelByMonthYear();

    const handleClose = () => {
        setOpen(false);
    }

    return(
        <Row>
            <Col lg={24} xs={24}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                    <Button
                        type="primary"
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        Descargar excel
                    </Button>
                </div>
                <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <Box sx={style}>
                    <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                        <select 
                            style={{ width: '100px', margin: '0 10px' }}
                            value={hook.month.toString()}
                            onChange={(e) => {
                                hook.setMonth(e.target.value);
                            }}
                            options={months}
                        >
                            {
                                months.map( (m, key) => (
                                    <option key={`option_months_${key}`} value={m.value}>{m.label}</option>
                                ))
                            }
                        </select>
                        <select
                            style={{ width: '100px', margin: '0 10px' }}
                            value={hook.year}
                            onChange={(e) => {
                                hook.setYear(e.target.value);
                            }}
                        >
                            {
                                years.map( (y, key) => (
                                    <option key={`option_year_${key}`} value={y.value}>{y.label}</option>
                                ))
                            }
                        </select>
                        {
                            hook.loading ? 
                                <div>Cargando...</div>
                            :
                            <Button
                                type="primary"
                                onClick={() => {
                                    hook.downloadExcel();
                                }}
                            >
                                Descargar
                            </Button>
                        }
                    </div>
                    </Grid>
                    </Grid>
                </Box>
                </Modal>
            </Col>
        </Row>
    );
}